import Api from '@/services/Api'

export default {
  updateByCompanyId (id, config) {
    return Api().put('/company/' + id + '/configuration', {config})
  },
  getByCompanyId (id) {
    return Api().get('/company/' + id + '/configuration')
  },
  instagramLoginCode (code) {
    return Api().post('/cp/instagram', {code})
  },
  getLanguages () {
    return Api().get('/config/languages')
  },
  getCountries () {
    return Api().get('/config/countries')
  },
  scrapeSocialLinks (website) {
    return Api().get('/config/scrape/social?website=' + website)
  },
  scrapeEmails (website) {
    return Api().get('/config/scrape/emails?website=' + website)
  },

  // Admin
  getAll () {
    return Api().get('/config')
  },
  create (data) {
    return Api().post('/config', data)
  },
  edit (data) {
    return Api().put('/config/' + data.id, data)
  },
  delete (data) {
    return Api().delete('/config/' + data.id)
  },
}
